module.exports = __webpack_public_path__ + "static/media/wuyating.0f32edf1.png";